<template>
  	<div class="stores" @click='topHide' style="height:100%">
    	<div class="breadcrumb">课程管理 > 课程限免配置</div>
	    <div class="searchBtn" style="border:none;display:flex">
	    	<el-button size='small' type="success" plain @click="LimitFree">限免</el-button>
	    	<el-button size='small' type="danger"  plain @click="cancelLimitFree">取消限免</el-button>
			<div class="topinput">
				<input type="text" placeholder="请输入教练名称" class="el-input__inner" v-model="nickname" @keyup="search" @keyup.enter="search_mine()"/>
				<ul class="nickNameul" v-if="fuzzyQueryShow">
					<li v-for="item in nicknameData" @click="nicknameitem(item.id,item.nickName)">{{item.nickName}}</li>
				</ul>
			</div>
	      	<el-date-picker
	      		v-model="timeVal"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="课程开始日期"
	      		end-placeholder="课程结束日期"
      			value-format="yyyy-MM-dd">
	    	</el-date-picker>
	    	<el-date-picker
	      		v-model="timeVal2"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="限免开始日期"
	      		end-placeholder="限免结束日期"
      			value-format="yyyy-MM-dd">
	    	</el-date-picker>
	    	<el-button type="primary" @click="search_mine()" style="margin-left:15px">搜索</el-button>

	    </div>
	    <div class="topnav" style="margin:15px 0 20px">
	    	<li :class="{active:cur==-1}" @click="topnav(-1)">全部</li>
	    	<li v-for="(item,index) in selData" :class="index==cur?'active':''" @click="topnav(index,item.id)">{{item.name}}</li>
	    </div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData" highlight-current-row  style="width: 100%" @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
	        		<el-table-column type="selection" width="55"></el-table-column>
			        <el-table-column prop="id" label="ID"></el-table-column>
			        <el-table-column prop="coachName" label="课程教练" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="name"  label="课程名称" show-overflow-tooltip></el-table-column>
			        <el-table-column  label="课程模式">
			        	<template slot-scope="scope">
			        		<span v-if='scope.row.chargeStatus==0'>当前：收费课程
			        		</span>
			        		<span v-else style="color:#3a8ee6">
			        			当前：限免课程 	
			        		</span>
			        		<div v-if="scope.row.courseFreeStartTime">限免开始：{{dateFormatq(scope.row.courseFreeStartTime)}}</div>
			        		<div v-if="scope.row.courseFreeEndTime">限免结束：{{dateFormatq(scope.row.courseFreeEndTime)}}</div>
			        	</template>
			        </el-table-column>
			        <el-table-column prop="sportKindName"  label="运动类型名称" show-overflow-tooltip></el-table-column></el-table-column>
			        <el-table-column prop="beginTime"  :formatter="this.global.dateFormat" label="课程开始时间" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="endTime" :formatter="this.global.dateFormat" label="课程结束时间" show-overflow-tooltip></el-table-column>
		        </el-table>
	      	</template>

	      	<el-button @click="toggleSelection()" style="margin-top:30px">取消选择</el-button>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	    </div>

	    <!-- 限免时间 -->
	    <el-dialog title="限免时间" :visible.sync="dialogVisible" width="25%" :before-close="handleClose">
	      	<el-date-picker
		      	v-model="LimitFreetimeVal"
		      	type="datetimerange"
		      	range-separator="至"
		      	start-placeholder="限免开始时间"
		      	end-placeholder="限免结束时间"
		      	value-format="timestamp" style="width:100%">
		    </el-date-picker >
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="LimitFreesubmit">确 定</el-button>
	      	</span>
	    </el-dialog>

  	</div>
</template>  
<script>
import moment from 'moment';
export default {
  	components: {},
  	mounted() {
  		this.userId=localStorage.getItem("userId")
    	this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
    	this.sportsKind()
  	},
  	data() {
    	return {
    		cur:-1,
    		userId:'',
    		coachId:'',
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
      		tableData: [], //初始化表格
      		selData:[],
      		pageNum: 1,
      		limit: 10,
      		totalPage: 10,
      		currentRow: "",
	      	sportsKindId: 0,
	      	nicknameData:[],
	      	nickname:'',
	      	fuzzyQueryShow:false,
	      	timeVal:'',

	      	dialogVisible:false,
	      	LimitFreetimeVal:'',//限免时间
	      	multipleSelection: [],
	      	timeVal2:''
	    };
  	},

  	methods: {
  		dateFormatq:function(time) {
		    var date = new Date(time);
		    var year=date.getFullYear();
		    var month=date.getMonth()+1<10?'0'+(date.getMonth()+1):date.getMonth()+1;
		    var day=date.getDate()<10?'0'+date.getDate():date.getDate();
		    var hours=date.getHours()<10?'0'+date.getHours():date.getHours();
		    var minutes=date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes();
		    var seconds=date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds();
		    return year+'-'+month+'-'+day+' '+hours+':'+minutes+':'+seconds   
		},
	    //初始化表格数据
	    page(pageNum,limit,userId,sportsKindId,coachId,nickname,beginTime,endTime){
	    	var params=this.calculate();
	    	this.$get("/course", params)
	        .then(res => {
	          	if (res.code == 0) {
	            	this.tableData = res.data.list;
	            	this.totalPage = res.data.total;

	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	        .catch(() => {
	         	console.log();
	        });
	    },
	    //选择运动种类
	    sportsKind() {
	      	this.$get("/course/sportsKind", {})
	        .then(res => {
	          	console.log(res)
	          	if (res.code == 0) {
	            	this.selData = res.data;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
	            	return false;
	          	}
	        })
	    },
	    calculate(){
	    	var dataFer = {
	    		pageNum:this.pageNum,
	    		limit:this.limit,
	    		userId:this.userId,
	        	sportsKindId:this.sportsKindId,
	        	nickname:this.nickname
		    }
		    if(this.coachId){
		    	dataFer.coachId=this.coachId
		    }
		    if(this.timeVal){	
		    	dataFer.beginTime=this.$moment(this.timeVal[0]).valueOf();
		    	dataFer.endTime=this.$moment(this.timeVal[1]).valueOf();
		    }
		    if(this.timeVal2){	
		    	dataFer.courseFreeStartTime=this.$moment(this.timeVal2[0]).valueOf();
		    	dataFer.courseFreeEndTime=this.$moment(this.timeVal2[1]).valueOf();
		    }
		    return dataFer;
	    },
	    search(){//模糊查询
	    	this.coachId='';
	  		if(this.nickname){
	  			var params = {
		        	pageNum: 1,
		        	limit: this.limit,
		        	nickname:this.nickname
		      	};
	  			this.$get("/coaches/nickname", params)
		        .then(res => {
		        	console.log(res)
		          	if (res.code == 0) {
		            	this.nicknameData=res.data.list;
		            	if(res.data.list.length>0){
		            		this.fuzzyQueryShow=true;
		            	}
		          	} else {
			            this.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		          	}
		        })
	  		}else{
	  			this.nicknameData=[];
	  			this.fuzzyQueryShow=false;
	  		}
	  	},
	  	nicknameitem(id,name){
	  		this.coachId=id;
	  		this.nickname=name;
	  		this.fuzzyQueryShow=false;
	  	},
	  	search_mine(){
	  		this.pageNum=1;
	  		this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
	  	},
	  	topHide(){
	  		this.fuzzyQueryShow=false;
	  	},
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
	    },
	    handleClose() {
	      	this.dialogVisible = false
	    },
	    //选择需要修改的权限
	    handleCurrentChange(val) {
	      	if (val) {
		        this.currentRow = val.id;
	      	}
	    },
	    topnav(e,id){
	    	if(e!=-1){
	    		this.sportsKindId=id
	    	}else{
	    		this.sportsKindId=0
	    	}
	    	this.pageNum=1;
 			this.cur=e;
 			this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
 		},
 		handleSelectionChange(val) {
	        this.multipleSelection = val;
	    },
	    toggleSelection(rows) {
	        this.$refs.multipleTable.clearSelection();
      	},
      	LimitFree(){
      		if(this.multipleSelection.length>0){
      			this.dialogVisible=true
      		}else{
      			this.$message({
	              	message: '至少选择一个课程',
	              	type: "warning"
	            });
      		}
      	},
      	LimitFreesubmit(){//添加限免时间
      		var that=this;
      		if(that.LimitFreetimeVal.length>0){
      			var newArr = [];
      			that.multipleSelection.forEach(function(val, index) {
				  	var newJson = JSON.stringify({ "startTime": that.LimitFreetimeVal[0], "endTime": that.LimitFreetimeVal[1], courseId: val.id });	
				  	newArr.push(JSON.parse(newJson));
				});
				that.$post("/course/addCourseFree",JSON.stringify(newArr))
		        .then(res => {
		          	if (res.code == 0) {
			            that.$message({
			              	message: "设置成功",
			              	type: "success"
			            });
			            that.LimitFreetimeVal='';
	                  	that.dialogVisible = false;
	                  	that.pageNum=1;
	                  	that.page(that.pageNum,that.limit,that.userId,that.sportsKindId,that.coachId,that.nickname,that.beginTime,that.endTime)
		          	} else {
			            that.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		          	}
		        })
      		}else{
      			that.$message({
	              	message: '请选择限免时间',
	              	type: "warning"
	            });
      		}	
      	},
      	cancelLimitFree(){//取消限免
      		var that=this;
      		if(that.multipleSelection.length>0){
      			var newArr = [];
      			that.multipleSelection.forEach(function(val, index) {
				  	var newJson = JSON.stringify({courseId: val.id });	
				  	newArr.push(JSON.parse(newJson));
				});
      			that.$post("/course/delCourseFree",JSON.stringify(newArr))
		        .then(res => {
		          	if (res.code == 0) {
			            that.$message({
			              	message: "取消成功",
			              	type: "success"
			            });
	                  	that.pageNum=1;
	                  	that.page(that.pageNum,that.limit,that.userId,that.sportsKindId,that.coachId,that.nickname,that.beginTime,that.endTime)
		          	} else {
			            that.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		          	}
		        })
      		}else{
      			that.$message({
	              	message: '至少选择一个课程',
	              	type: "warning"
	            });
      		}
      	}
  	}
};
</script>

<style scoped>
::deep
.el-date-editor .el-range-separator{
	padding: 0
}
.searchBtn .el-range-editor.el-input__inner{
	margin:0 0 0 15px
}
.topinput{
	position: relative;
	width: 250px;
	margin-left: 15px;
}
.topinput input{
	font-size: 13px;
}
.nickNameul{
	position: absolute;
	background: #fff;
	width: 100%;
	padding: 10px;
	font-size: 13px;
	line-height: 25px;
	border: 1px solid #DCDFE6;
	border-top: none
}
.nickNameul li{
	color: #666;
	cursor: pointer;
}
.nickNameul li:hover{
	color: #409EFF
}
</style>



// WEBPACK FOOTER //
// src/views/coursesList/courseFreeConfiguration.vue